import React, { useCallback, useState, useEffect, useRef } from "react";
import Layout from "../Layout/Layout";
import { getElakayLang, isAuthenticated } from "../auth";
import { updateLanguageElakay, updateLanguageElakay0, reorderLanguageElakay0, deleteLanguageElakay0, updateLanguageFileUp, allLanguageElakay, LanguageElakayByTUID, LanguageElakayByLanguage } from "../auth/apiLanguage"
import FormPageLang from "./LanguagePage/formPageLang";
import FormPageLang0 from "./LanguagePage/formPageLang0";
import FormPageLang1 from "./LanguagePage/formPageLang1";
import FormPageErrorElakay from "./LanguagePage/formPageErrorElakay"
import FormPageDataMail from "./LanguagePage/formPageDataMail"
import FormPageTicket from "./LanguagePage/formPageTicket";
import CodeEdit from "./LanguagePage/codeEdit";
import CheckLngToFinish from "./LanguagePage/CheckLngtofinish";
import LanguageManagerDashboard from "./LanguagePage/LanguageManagerDashboard";
import { CONTENT_PAGE_KEYS as CONTENT_KEYS } from "./contentPageUtils";
import { laguangeElakay } from "../pageInside/dataElakay";
import { Family } from "../pageInside/Rolle"
import AlertPage from "../pageInside/alertPage";
import ErrorAlert from "../pageInside/ErrorAlert";

import "./AddLanguage.css"
import { elakayAutoText } from "../pageInside/dataElakay";
 

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addLanguage"]?.[key] || fallback;

const getAvailableLanguages = () => [
  { code: "en", name: "English", label: __elakayText("t009", "English"), nativeName: "English" },
  { code: "es", name: "Spanish; Castilian", label: __elakayText("t010", "Spanish; Castilian"), nativeName: "español, castellano" },
  { code: "ht", name: "Haitian; Haitian Creole", label: __elakayText("t011", "Haitian; Haitian Creole"), nativeName: "Kreyòl ayisyen" },
  { code: "fr", name: "French", label: __elakayText("t012", "French"), nativeName: "français, langue française" },
  { code: "pt", name: "Portuguese", label: __elakayText("t013", "Portuguese"), nativeName: "Português" },
]

// ─── Design tokens ────────────────────────────────────────────────────────────
const D = {
  sidebarBg:    "#0f172a",
  sidebarHdr:   "#1e293b",
  sidebarBdr:   "#1e293b",
  sidebarText:  "#94a3b8",
  sidebarHover: "rgba(148,163,184,.08)",
  sidebarActive:"#1e3a5f",
  sidebarActTxt:"#93c5fd",
  sidebarActBdr:"#3b82f6",
  contentBg:    "#f1f5f9",
  cardBg:       "#ffffff",
  cardBdr:      "#e2e8f0",
  headerBg:     "#0f172a",
  blue:         "#3b82f6",
  blueLight:    "#dbeafe",
  green:        "#10b981",
  greenLight:   "#d1fae5",
  red:          "#ef4444",
  redLight:     "#fee2e2",
  yellow:       "#f59e0b",
  yellowLight:  "#fef3c7",
  txt1:         "#0f172a",
  txt2:         "#475569",
  txt3:         "#94a3b8",
  font:         "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif",
};

// ─── Primitives ───────────────────────────────────────────────────────────────
const card = (extra = {}) => ({
  background: D.cardBg, border: `1px solid ${D.cardBdr}`,
  borderRadius: 12, padding: "20px 24px", ...extra,
});

const badge = (color, bg) => ({
  display: "inline-flex", alignItems: "center",
  padding: "2px 10px", borderRadius: 20,
  fontSize: 11, fontWeight: 600,
  color, background: bg, letterSpacing: 0.3,
});

const SPECIAL_KEY_GROUP = {
  elakayMail:      'email',
  errorMessage:    'errors',
  advertisingEmail:'code',
  allElakayFile:   'files',
  elakayTicket:    'tickets',
};

const GROUPS = [
  { id: 'navigation', get label() { return elakayAutoText("h_061a51fbf2bbc8", "Navigation & UI"); },   icon: '☰',  dot: '#3b82f6', familyOnly: false },
  { id: 'content',    get label() { return elakayAutoText("h_505a70114c9efd", "Content Pages"); },      icon: '▤',  dot: '#8b5cf6', familyOnly: false },
  { id: 'email',      get label() { return elakayAutoText("h_9012a6e435cc8c", "Email Templates"); },    icon: '✉',  dot: '#f59e0b', familyOnly: false },
  { id: 'errors',     get label() { return elakayAutoText("h_fa647c1ab7e459", "Error Messages"); },     icon: '⚡', dot: '#ef4444', familyOnly: false },
  { id: 'code',       get label() { return elakayAutoText("h_a971080c2944ea", "Advertising Code"); },   icon: '{}', dot: '#06b6d4', familyOnly: true  },
  { id: 'files',      get label() { return elakayAutoText("h_1fd21b18928a09", "Files & Media"); },      icon: '▣',  dot: '#10b981', familyOnly: true  },
  { id: 'tickets',    get label() { return elakayAutoText("h_6564b0b371ad48", "Support Tickets"); },    icon: '◈',  dot: '#f97316', familyOnly: true  },
];

const getGroupId = (key) => {
  if (SPECIAL_KEY_GROUP[key]) return SPECIAL_KEY_GROUP[key];
  if (CONTENT_KEYS.includes(key)) return 'content';
  return 'navigation';
};

const EMPTY_PAGE_VALUE = Object.freeze({
  title: '',
  text: '',
  list: '',
  VORI: '',
  imagePath: '',
  videoPath: '',
  video: '',
  thumbnail: '',
  image: '',
  href: '',
  link: '',
});

const isMissingTranslation = (value) => (
  value === undefined ||
  value === null ||
  value === '' ||
  (Array.isArray(value) && value.length === 0) ||
  (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
);

// ─────────────────────────────────────────────────────────────────────────────
const AddLanguage = (props) => {
  const { infoSource } = props;
  __setElakayInfoSource(infoSource);
  const availableLanguages = getAvailableLanguages();

  const elakayInfo = infoSource?.languageAPI?.elakayInfo || {};
  const { token = '' } = isAuthenticated() || {};

  const ObjetPage = EMPTY_PAGE_VALUE;
  const ObjetCoding = {
    jsonText: '{ "subject": "elakay email"}',
    subject: '',
    HTLMCSStext: '<div><h2>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t001}</h2></div>',
  }

  const [errorMessage, setErrorMessage]   = useState(null);
  const [pageSelected, setPageSelected]   = useState(Family() ? 'aboutUs' : 'headNenu');
  const loading                           = false;
  const [compLanguage, setCompLanguage]   = useState('');
  const [paragra, setParagra]             = useState(ObjetPage);
  const [coding, setCoding]               = useState(ObjetCoding);
  const [languageTradictor, setLanguageTradictor] = useState({});
  const [allLanguageDocuments, setAllLanguageDocuments] = useState([]);
  const [languageOne, setLanguageOne]     = useState({});
  const [languageTwo, setLanguageTwo]     = useState({});
  const [languageThree, setLanguageThree] = useState({});
  const [editAdd, setEditAdd]             = useState(true);
  const [showCheckLang, setShowCheckLang] = useState(false);
  const [getDataEmail, setDataEmail]      = useState([]);
  const [getDataMessErr, setDataMessErr]  = useState([]);
  const [showAlert, setShowAlert]         = useState(false);
  const [error, setError]                 = useState(null);
  const divLoadingPage                    = useRef(null);
  const [jsonInput, setJsonInput]         = useState('');
  const [objet, setObejet]                = useState(() => ConvertToEmptyObj(elakayInfo[pageSelected]));
  const [expandedGroups, setExpandedGroups] = useState(() => new Set([getGroupId(Family() ? 'aboutUs' : 'headNenu')]));
  const [sidebarSearch, setSidebarSearch]   = useState('');

  function ConvertToEmptyObj(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
    return Object.keys(value).reduce((result, key) => {
      result[key] = '';
      return result;
    }, {});
  }

  const checkProdKeyExit = (value) => !isMissingTranslation(value);

  const checkEditPro = (ad) => {
    let ent = Object.keys(ad ? ad : []);
    return ent?.length > 0 ? true : false
  }

  const checkUndefName = (a, b) => {
    let aa = a && Object.keys(a)
    return a && aa.includes(b)
  }

  const scrollToParagraph = (ref) => {
    if (ref && ref.current) ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  const handlelanguage = (a) => event => {
    const value = event.target.value;
    const all = availableLanguages.find(l => l.code === value);
    if (!all) return;
    LanguageElakayByLanguage(all, false).then(data => {
      if (data.error) setError(data.error);
      else a(data);
    });
  };

  const handleDatamail = (objName) => {
    LanguageElakayByLanguage({ "code": "en", "name": __elakayText("t009", "English"), "nativeName": "English" }, false).then(data => {
      if (data.error) setError(data.error);
      else {
        setDataEmail(data["advertisingEmail"])
        setDataMessErr(data[objName])
      }
    });
  }

  const languageUsertra = useCallback(async () => {
    const { obj } = getElakayLang() || {};
    const data = await LanguageElakayByTUID(token, obj?.name || "English", Boolean(Family()));
    if (data.error) setError(data.error);
    else setLanguageTradictor(data);
    return data;
  }, [token]);

  const AlllanguageSelect = useCallback(async () => {
    const data = await allLanguageElakay(false);
    if (data.error) setError(data.error);
    else setAllLanguageDocuments(Array.isArray(data) ? data : []);
    return data;
  }, []);

  useEffect(() => {
    languageUsertra();
    AlllanguageSelect();
  }, [languageUsertra, AlllanguageSelect]);

  const toggleGroup = (id) => {
    setExpandedGroups(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const clickPageseleted = (a) => {
    setCompLanguage('')
    checkEditPro(languageTradictor[a]) ? setEditAdd(false) : setEditAdd(true)
    setDataEmail([])
    scrollToParagraph(divLoadingPage)
    setObejet(ConvertToEmptyObj(elakayInfo[a]))
    setParagra(ObjetPage)
    setPageSelected(a)
    languageUsertra()
    a === 'errorMessage' && handleDatamail(a)
    a === 'elakayMail' && handleDatamail(a)
    setExpandedGroups(prev => new Set([...prev, getGroupId(a)]))
  }

  const handleLanguage = () => event => {
    const value = event.target.value;
    setCompLanguage(value);
    pageSelected === "" && setPageSelected('headNenu');
  };

  const inputOK = (a, b, c) => {
    if (c === undefined) { return { v: b, s: 'form-control' } }
    else if (c && typeof c === 'object' && Object.keys(c).length === 0) { return { v: "", s: 'form-control is-invalid' } }
    else if (checkUndefName(c, a)) { return { v: c[a], s: "form-control is-valid" } }
    else { return { v: "", s: 'form-control is-invalid' } }
  }

  const copyToClipboard = (jsonData) => {
    const jsonStr = JSON.stringify(jsonData, null, 2);
    navigator.clipboard.writeText(jsonStr).then(() => {
      setShowAlert(true)
    }).catch((err) => { console.error('Erreur lors de la copie : ', err); });
  };

  const checkLangDefault = (value, fallback, key) => (
    value && checkProdKeyExit(value[key]) ? value : fallback
  );

  const entriesLang = (a = {}) => Object.entries(a?.[pageSelected] || {})
  const entriesLang0 = (a = {}) => Object.entries(checkLangDefault(a, elakayInfo, pageSelected)?.[pageSelected] || {})
  const checkValue = (val) => languageTradictor[pageSelected] !== undefined ? languageTradictor[pageSelected] : val

  const checKL_L1 = isMissingTranslation(languageTradictor[pageSelected]);

  const submitJsonInput = () => {
    try {
      setObejet(JSON.parse(jsonInput))
      setLanguageTradictor({ ...languageTradictor, [pageSelected]: JSON.parse(jsonInput) })
      setErrorMessage(null)
    } catch (error) {
      setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }));
    }
  }

  // ─── Rendering helpers ──────────────────────────────────────────────────────

  const showError = (a) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLight, borderRadius: 8, border: `1px solid #fca5a5`, marginTop: 8 }}>
      <span style={{ fontSize: 16 }}>⚠</span>
      <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{a}</span>
    </div>
  );

  const LanguageSeleted = (a) => (
    <div style={{ marginTop: 12 }}>
      <select onChange={handlelanguage(a)}
        style={{ width: "100%", padding: "7px 10px", borderRadius: 8, border: `1px solid ${D.cardBdr}`, fontSize: 12, color: D.txt2, background: "#f8fafc", outline: "none", cursor: "pointer", fontFamily: D.font }}>
        <option>{infoSource.language(infoSource, "Label", "ChoLang")}</option>
        {availableLanguages.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
      </select>
    </div>
  );

  const InputPage = (a, b, i, c) => {
    const { v, s } = inputOK(a, b, c);
    const isValid   = s.includes("is-valid");
    const isInvalid = s.includes("is-invalid");
    const borderColor = isValid ? D.green : isInvalid ? D.red : D.cardBdr;
    const bgColor     = isValid ? "#f0fdf4" : isInvalid ? "#fff5f5" : "#fafafa";

    return b && (
      <div key={i} style={{ marginBottom: 6 }}>
        {b?.length > 90
          ? <textarea readOnly value={v} rows={3}
              style={{ width: "100%", padding: "6px 10px", border: `1px solid ${borderColor}`, borderRadius: 6, fontSize: 12, color: D.txt2, background: bgColor, fontFamily: "monospace", resize: "vertical", boxSizing: "border-box" }} />
          : <input readOnly type="text" value={v}
              style={{ width: "100%", padding: "6px 10px", border: `1px solid ${borderColor}`, borderRadius: 6, fontSize: 12, color: D.txt2, background: bgColor, boxSizing: "border-box" }} />
        }
      </div>
    );
  };

  const InputPageArray1 = (a, b, i) => (
    <div key={i} style={{ marginBottom: 6 }}>
      {a === 'title' && <input readOnly type="text" value={b}
        style={{ width: "100%", padding: "6px 10px", border: `1px solid ${D.cardBdr}`, borderRadius: 6, fontSize: 12, color: D.txt2, background: "#fafafa" }} />}
      {a === 'text' && b?.map((x, u) => x !== '' &&
        <p key={u} style={{ fontSize: 12, color: D.txt2, margin: "2px 0", lineHeight: 1.5 }}>{x}</p>)}
      {a === 'list' && <ol type="a" style={{ paddingLeft: 20, margin: 0, fontSize: 12, color: D.txt2 }}>
        {b?.map((a, i) => a !== '' && <li key={i} style={{ marginBottom: 2 }}>{a}</li>)}
      </ol>}
    </div>
  );

  const InputPageArray0 = (a, j) => {
    let oe = Object.entries(a)
    return <div key={j}>{oe?.map(([key, val], i) => InputPageArray1(key, val, i))}</div>
  };

  const buttonAddLanguage = (clickAdd, ok) => (
    <button type="button" onClick={ok ? clickAdd : undefined} disabled={!ok}
      style={{ padding: "8px 20px", borderRadius: 8, border: "none", background: ok ? D.blue : "#cbd5e1", color: ok ? "#fff" : "#94a3b8", fontSize: 13, fontWeight: 600, cursor: ok ? "pointer" : "not-allowed", fontFamily: D.font, transition: "background .15s" }}>
      {infoSource.language(infoSource, 'Button', "submit")}
    </button>
  );

  // ─── Sidebar ────────────────────────────────────────────────────────────────
  const linksData = infoSource.laguangeElakay('menuAddLang', infoSource.languageAPI);

  const sideBarForm = () => {
    // Build group → items map from linksData
    const groupItems = {};
    let checkLngLabel = null;
    Object.entries(linksData).forEach(([key, label]) => {
      if (key === 'checkLngToFinish') { checkLngLabel = label; return; }
      const gid = getGroupId(key);
      if (!groupItems[gid]) groupItems[gid] = [];
      groupItems[gid].push({ key, label });
    });

    const q = sidebarSearch.toLowerCase();

    return (
      <div style={{
        width: 264, minWidth: 264, background: D.sidebarBg,
        display: "flex", flexDirection: "column",
        borderRight: `1px solid ${D.sidebarBdr}`, fontFamily: D.font,
      }}>
        {/* Header */}
        <div style={{ padding: "16px 18px 12px", borderBottom: `1px solid ${D.sidebarBdr}` }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: D.sidebarText, textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 2 }}>
            Elakay
          </div>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#e2e8f0", marginBottom: 12 }}>
            {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t008}
          </div>
          {/* Search */}
          <div style={{ position: "relative" }}>
            <span style={{ position: "absolute", left: 9, top: "50%", transform: "translateY(-50%)", fontSize: 11, color: D.sidebarText, pointerEvents: "none" }}>
              🔍
            </span>
            <input
              value={sidebarSearch}
              onChange={e => setSidebarSearch(e.target.value)}
              placeholder={elakayAutoText("h_d09a6b6cfde1cf", "Search pages…")}
              style={{
                width: "100%", padding: "6px 8px 6px 26px", boxSizing: "border-box",
                background: "#1e293b", border: `1px solid #334155`, borderRadius: 6,
                color: "#e2e8f0", fontSize: 12, outline: "none", fontFamily: D.font,
              }}
            />
          </div>
        </div>

        {/* Groups */}
        <div style={{ flex: 1, overflowY: "auto", padding: "6px 0" }}>
          {GROUPS.map(group => {
            if (group.familyOnly && !Family()) return null;
            const items = (groupItems[group.id] || []).filter(({ label }) =>
              !q || label.toLowerCase().includes(q)
            );
            if (items.length === 0) return null;
            const isOpen = expandedGroups.has(group.id) || q.length > 0;

            return (
              <div key={group.id}>
                {/* Group header */}
                <button
                  type="button"
                  onClick={() => toggleGroup(group.id)}
                  style={{
                    display: "flex", alignItems: "center", gap: 8, width: "100%",
                    padding: "8px 18px", background: "transparent", border: "none",
                    cursor: "pointer", textAlign: "left", fontFamily: D.font,
                  }}
                >
                  {/* Colored dot */}
                  <span style={{
                    width: 6, height: 6, borderRadius: "50%",
                    background: group.dot, flexShrink: 0, marginTop: 1,
                  }} />
                  <span style={{
                    flex: 1, fontSize: 10, fontWeight: 700, color: "#64748b",
                    textTransform: "uppercase", letterSpacing: 1.2,
                  }}>
                    {group.label}
                  </span>
                  {/* Count badge */}
                  <span style={{
                    fontSize: 10, fontWeight: 700, color: group.dot,
                    background: `${group.dot}22`, borderRadius: 10,
                    padding: "1px 6px", marginRight: 4,
                  }}>
                    {items.length}
                  </span>
                  {/* Chevron */}
                  <span style={{
                    fontSize: 9, color: "#475569",
                    transition: "transform .15s",
                    display: "inline-block",
                    transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                  }}>
                    ▶
                  </span>
                </button>

                {/* Items */}
                {isOpen && items.map(({ key, label }) => {
                  const active = pageSelected === key;
                  return (
                    <button
                      key={key}
                      type="button"
                      onClick={() => clickPageseleted(key)}
                      style={{
                        display: "flex", alignItems: "center", width: "100%",
                        padding: "7px 18px 7px 34px",
                        background: active ? D.sidebarActive : "transparent",
                        border: "none",
                        borderLeft: `3px solid ${active ? group.dot : "transparent"}`,
                        cursor: "pointer", textAlign: "left",
                        color: active ? "#e2e8f0" : D.sidebarText,
                        fontSize: 12, fontWeight: active ? 600 : 400,
                        fontFamily: D.font, transition: "all .12s",
                      }}
                      onMouseEnter={e => {
                        if (!active) {
                          e.currentTarget.style.background = D.sidebarHover;
                          e.currentTarget.style.color = "#cbd5e1";
                        }
                      }}
                      onMouseLeave={e => {
                        if (!active) {
                          e.currentTarget.style.background = "transparent";
                          e.currentTarget.style.color = D.sidebarText;
                        }
                      }}
                    >
                      {active && (
                        <span style={{
                          width: 5, height: 5, borderRadius: "50%",
                          background: group.dot, flexShrink: 0, marginRight: 6,
                        }} />
                      )}
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {label}
                      </span>
                    </button>
                  );
                })}
              </div>
            );
          })}

          {/* Check-lang special action */}
          {checkLngLabel && Family() && (
            <div style={{ borderTop: `1px solid ${D.sidebarBdr}`, marginTop: 6, paddingTop: 6 }}>
              <button
                type="button"
                onClick={() => setShowCheckLang(true)}
                style={{
                  display: "flex", alignItems: "center", gap: 8, width: "100%",
                  padding: "8px 18px", background: "transparent", border: "none",
                  cursor: "pointer", textAlign: "left", fontFamily: D.font,
                  color: "#f59e0b", fontSize: 12, fontWeight: 700,
                }}
              >
                <span style={{ fontSize: 13 }}>✓</span>
                {checkLngLabel}
              </button>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: "12px 18px", borderTop: `1px solid ${D.sidebarBdr}` }}>
          {Family()
            ? <span style={{ ...badge("#fbbf24", "#451a03"), padding: "3px 10px" }}>{elakayAutoText("h_6f634fb46222c2", "👑 Developer")}</span>
            : <span style={{ ...badge("#94a3b8", "#1e293b"), padding: "3px 10px" }}>{elakayAutoText("h_1fafc51374f712", "Translator")}</span>
          }
        </div>
      </div>
    );
  };

  // ─── Compare section helpers ─────────────────────────────────────────────────
  const compareLanguages = () => (
    <div>
      <label style={{ fontSize: 11, fontWeight: 700, color: D.txt3, textTransform: "uppercase", letterSpacing: 0.8, display: "block", marginBottom: 6 }}>
        {infoSource.language(infoSource, "label", "selLanguaComp")}
      </label>
      <select onChange={handleLanguage()} value={compLanguage}
        style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: `1px solid ${D.cardBdr}`, background: "#fff", fontSize: 13, color: D.txt1, outline: "none", cursor: "pointer", fontFamily: D.font }}>
        <option value="">{infoSource.language(infoSource, "label", "nolangSelComp")}</option>
        <option value="addByJson">{infoSource.language(infoSource, "title", "addTradJson")}</option>
        <option value="language1">{infoSource.language(infoSource, "label", "selLangcompTracd")}</option>
        <option value="language2">{infoSource.language(infoSource, "label", "sel2langComp")}</option>
        <option value="language3">{infoSource.language(infoSource, "label", "sel3langComp")}</option>
      </select>
    </div>
  );

  const CompareColCard = ({ title, children, onCopy }) => (
    <div style={{ background: "#f8fafc", borderRadius: 10, border: `1px solid ${D.cardBdr}`, padding: 16, display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
        <h5 style={{ fontSize: 11, fontWeight: 700, color: D.txt3, textTransform: "uppercase", letterSpacing: 0.8, margin: 0 }}>{title}</h5>
        {onCopy && (
          <button onClick={onCopy}
            style={{ padding: "3px 10px", borderRadius: 6, border: `1px solid ${D.cardBdr}`, background: "#fff", color: D.txt2, fontSize: 11, cursor: "pointer", fontFamily: D.font }}>
            {infoSource.language(infoSource, 'Button', "copyJson")}
          </button>
        )}
      </div>
      {children}
    </div>
  );

  const compare1Page = () => compLanguage === "language1" && (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginTop: 16 }}>
      <CompareColCard
        title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t002}
        onCopy={() => copyToClipboard(checkLangDefault(languageOne, elakayInfo, pageSelected)[pageSelected])}>
        {Array.isArray(checkLangDefault(languageOne, elakayInfo, pageSelected)[pageSelected])
          ? checkLangDefault(languageOne, elakayInfo, pageSelected)[pageSelected]?.map((oa, j) => InputPageArray0(oa, j))
          : entriesLang0(languageOne)?.map(([key, val], i) => InputPage(key, val, i))}
        {LanguageSeleted(setLanguageOne)}
      </CompareColCard>

      <CompareColCard
        title={infoSource.language(infoSource, "title", "YoTracdic")}
        onCopy={() => copyToClipboard(checkLangDefault(languageTradictor, elakayInfo, pageSelected)[pageSelected])}>
        {Array.isArray(checkLangDefault(languageTradictor, elakayInfo, pageSelected)[pageSelected])
          ? checkLangDefault(languageTradictor, elakayInfo, pageSelected)[pageSelected]?.map((oa, j) => InputPageArray0(oa, j))
          : entriesLang(elakayInfo)?.length > 0
            ? entriesLang(elakayInfo)?.map(([key, val], i) => InputPage(key, val, i, checkValue({})))
            : showError('you do not have data translate for this title')}
      </CompareColCard>
    </div>
  );

  const compare2Page = () => compLanguage === "language2" && (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginTop: 16 }}>
      <CompareColCard
        title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t003}>
        {Array.isArray(checkLangDefault(languageOne, elakayInfo, pageSelected)[pageSelected])
          ? checkLangDefault(languageOne, elakayInfo, pageSelected)[pageSelected]?.map((oa, j) => InputPageArray0(oa, j))
          : entriesLang0(languageOne)?.length > 0
            ? entriesLang0(languageOne)?.map(([key, val], i) => InputPage(key, val, i))
            : showError('this title does not have data translate')}
        {LanguageSeleted(setLanguageOne)}
      </CompareColCard>

      <CompareColCard
        title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t004}>
        {Array.isArray(checkLangDefault(languageTwo, elakayInfo, pageSelected)[pageSelected])
          ? checkLangDefault(languageTwo, elakayInfo, pageSelected)[pageSelected]?.map((oa, j) => InputPageArray0(oa, j))
          : entriesLang0(languageTwo)?.length > 0
            ? entriesLang0(languageTwo)?.map(([key, val], i) => InputPage(key, val, i))
            : showError('this title does not have data translate')}
        {LanguageSeleted(setLanguageTwo)}
      </CompareColCard>
    </div>
  );

  const compare3Page = () => compLanguage === "language3" && (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginTop: 16 }}>
      {[
        { title: infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t005, lang: languageOne, setter: setLanguageOne },
        { title: infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t006, lang: languageTwo, setter: setLanguageTwo },
        { title: infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t007, lang: languageThree, setter: setLanguageThree },
      ].map(({ title, lang, setter }, idx) => (
        <CompareColCard key={idx} title={title}>
          {Array.isArray(checkLangDefault(lang, elakayInfo, pageSelected)[pageSelected])
            ? checkLangDefault(lang, elakayInfo, pageSelected)[pageSelected]?.map((oa, j) => InputPageArray0(oa, j))
            : entriesLang0(lang)?.length > 0
              ? entriesLang0(lang)?.map(([key, val], i) => InputPage(key, val, i))
              : showError('this title does not have data translate')}
          {LanguageSeleted(setter)}
        </CompareColCard>
      ))}
    </div>
  );

  const addByJson = () => compLanguage === "addByJson" && (
    <div style={{ marginTop: 16 }}>
      <div style={{ marginBottom: 12 }}>
        <h4 style={{ fontSize: 13, fontWeight: 700, color: D.txt1, margin: 0 }}>
          {infoSource.language(infoSource, "title", "copyTradJson")}
        </h4>
      </div>
      {errorMessage && (
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "10px 14px", background: D.redLight, borderRadius: 8, border: `1px solid #fca5a5`, marginBottom: 12 }}>
          <span style={{ fontSize: 16, flexShrink: 0 }}>⚠</span>
          <span style={{ fontSize: 12, color: "#991b1b" }}>{errorMessage}</span>
        </div>
      )}
      <textarea
        onChange={(e) => setJsonInput(e.target.value)}
        placeholder={JSON.stringify(checkLangDefault(languageTradictor, elakayInfo, pageSelected)[pageSelected], null, 3)}
        style={{ width: "100%", minHeight: 240, padding: "12px 14px", border: `1px solid ${D.cardBdr}`, borderRadius: 8, fontFamily: "monospace", fontSize: 12, color: D.txt1, background: "#f8fafc", resize: "vertical", outline: "none", boxSizing: "border-box" }}
      />
      <div style={{ display: "flex", gap: 10, marginTop: 10, justifyContent: "flex-end" }}>
        <button onClick={() => copyToClipboard(checkLangDefault(languageTradictor, elakayInfo, pageSelected)[pageSelected])}
          style={{ padding: "8px 18px", borderRadius: 8, border: `1px solid ${D.cardBdr}`, background: "#fff", color: D.txt2, fontSize: 13, cursor: "pointer", fontFamily: D.font }}>
          {infoSource.language(infoSource, 'Button', "copyJson")}
        </button>
        <button onClick={() => submitJsonInput()}
          style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: D.blue, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}>
          {infoSource.language(infoSource, 'Button', "submit")} {__elakayText("t014", "json")}
        </button>
      </div>
    </div>
  );

  // ─── Form loaders (logic unchanged) ─────────────────────────────────────────
  const loadingFormPage = (o, so) => (
    <FormPageLang laguangeElakay={laguangeElakay} infoSource={infoSource} objet={o} setObejet={so}
      editAdd={editAdd} setEditAdd={setEditAdd} menu={ConvertToEmptyObj(elakayInfo[pageSelected])}
      nameObj={pageSelected} infoElakay={elakayInfo[pageSelected]} edit_add={checKL_L1}
      AlllanguageSelect={AlllanguageSelect} languageUsertra={languageUsertra} token={token}
      languageTradictor={languageTradictor} updateLanguageElakay={updateLanguageElakay}
      buttonAddLanguage={buttonAddLanguage} setError={setError} />
  );

  const loadingFormPage0 = (o, so) => (
    <FormPageLang0 laguangeElakay={laguangeElakay} infoSource={infoSource} editAdd={editAdd}
      editAddByJson={compLanguage === "addByJson"} paragra={o} setParagra={so} ObjetPage={ObjetPage}
      setEditAdd={setEditAdd} nameObj={pageSelected} edit_add={checKL_L1}
      AlllanguageSelect={AlllanguageSelect} languageUsertra={languageUsertra} token={token}
      languageTradictor={languageTradictor} updateLanguageElakay0={updateLanguageElakay0}
      reorderLanguageElakay0={reorderLanguageElakay0}
      deleteLanguageElakay0={deleteLanguageElakay0} updateLanguageFileUp={updateLanguageFileUp}
      buttonAddLanguage={buttonAddLanguage} setError={setError} />
  );

  const loadingFormPage1 = (o, so) => (
    <CodeEdit laguangeElakay={laguangeElakay} infoSource={infoSource} editAdd={editAdd}
      paragra={o} setParagra={so} ObjetPage={ObjetPage} setEditAdd={setEditAdd}
      nameObj={pageSelected} edit_add={checKL_L1} AlllanguageSelect={AlllanguageSelect}
      languageUsertra={languageUsertra} token={token} languageTradictor={languageTradictor}
      updateLanguageElakay0={updateLanguageElakay0} deleteLanguageElakay0={deleteLanguageElakay0}
      setError={setError} />
  );

  const loadingFormPageEmail = (o, so) => (
    <FormPageDataMail laguangeElakay={laguangeElakay} infoSource={infoSource}
      getDataEmail={getDataEmail} getDataMessErr={getDataMessErr} editAdd={editAdd}
      paragra={o} setParagra={so} ObjetPage={ObjetPage} editAddByJson={compLanguage === "addByJson"}
      setEditAdd={setEditAdd} nameObj={pageSelected} edit_add={checKL_L1}
      AlllanguageSelect={AlllanguageSelect} languageUsertra={languageUsertra} token={token}
      languageTradictor={languageTradictor} updateLanguageElakay0={updateLanguageElakay0}
      deleteLanguageElakay0={deleteLanguageElakay0} setError={setError} />
  );

  const loadingFormPageError = (o, so) => (
    <FormPageErrorElakay infoSource={infoSource} objet={o} setObejet={so} editAdd={editAdd}
      setEditAdd={setEditAdd} menu={ConvertToEmptyObj(elakayInfo[pageSelected])}
      editAddByJson={compLanguage === "addByJson"} nameObj={pageSelected}
      infoElakay={elakayInfo[pageSelected]} edit_add={checKL_L1} getDataEmail={getDataEmail}
      getDataMessErr={getDataMessErr} AlllanguageSelect={AlllanguageSelect}
      languageUsertra={languageUsertra} token={token} languageTradictor={languageTradictor}
      updateLanguageElakay0={updateLanguageElakay0} deleteLanguageElakay0={deleteLanguageElakay0}
      buttonAddLanguage={buttonAddLanguage} setError={setError} />
  );

  const loadingFormPage2 = () => (
    <CheckLngToFinish elakayInfo={elakayInfo} linksData={linksData}
      showCheckLang={showCheckLang} setShowCheckLang={setShowCheckLang}
      languageTradictor={languageTradictor}
      activeLink={activeLink} clickPageseleted={clickPageseleted} />
  );

  const loadingFilles = (o, so) => (
    <>
    <FormPageLang1 laguangeElakay={laguangeElakay} infoSource={infoSource} editAdd={editAdd}
      paragra={o} setParagra={so} ObjetPage={ObjetPage} editAddByJson={compLanguage === "addByJson"}
      setEditAdd={setEditAdd} nameObj={pageSelected} edit_add={checKL_L1}
      AlllanguageSelect={AlllanguageSelect} languageUsertra={languageUsertra} token={token}
      languageTradictor={languageTradictor} updateLanguageElakay0={updateLanguageElakay0}
      deleteLanguageElakay0={deleteLanguageElakay0} updateLanguageFileUp={updateLanguageFileUp}
      buttonAddLanguage={buttonAddLanguage} setError={setError} />
      </>
  );

  const loadingTicket = (o, so) => (
    <FormPageTicket laguangeElakay={laguangeElakay} editAddByJson={compLanguage === "addByJson"}
      infoSource={infoSource} editAdd={editAdd} paragra={o} setParagra={so} ObjetPage={ObjetPage}
      setEditAdd={setEditAdd} nameObj={pageSelected} edit_add={checKL_L1}
      AlllanguageSelect={AlllanguageSelect} languageUsertra={languageUsertra} token={token}
      languageTradictor={languageTradictor} updateLanguageElakay0={updateLanguageElakay0}
      deleteLanguageElakay0={deleteLanguageElakay0} updateLanguageFileUp={updateLanguageFileUp}
      buttonAddLanguage={buttonAddLanguage} setError={setError} />
  );

  const activeLink = (a) => pageSelected === a ? 'active' : 'notActive';

  // ─── Page router ─────────────────────────────────────────────────────────────
  const LoadingPage = (a) => {
    if (a === 'advertisingEmail')  return loadingFormPage1(coding, setCoding);
    if (a === 'checkLngToFinish')  return loadingFormPage2(paragra, setParagra);
    if (a === 'allElakayFile')     return loadingFilles(paragra, setParagra);
    if (a === 'elakayTicket')      return loadingTicket(paragra, setParagra);
    if (a === 'elakayMail')        return loadingFormPageEmail(paragra, setParagra);
    if (a === 'errorMessage')      return loadingFormPageError(paragra, setParagra);
    if (CONTENT_KEYS.includes(a))  return loadingFormPage0(paragra, setParagra);
    return loadingFormPage(objet, setObejet);
  };

  // ─── Main content ─────────────────────────────────────────────────────────────
  const contentForm = () => {
    const currentGroup = GROUPS.find(g => g.id === getGroupId(pageSelected));

    return (
      <div style={{ flex: 1, padding: "24px 28px", overflowY: "auto", fontFamily: D.font }}>

        {Family() && (
          <LanguageManagerDashboard
            documents={allLanguageDocuments}
            onRefresh={AlllanguageSelect}
          />
        )}

        {/* Breadcrumb + title bar */}
        <div style={{ marginBottom: 20 }}>
          {/* Breadcrumb */}
          {currentGroup && (
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
              <span style={{
                width: 7, height: 7, borderRadius: "50%",
                background: currentGroup.dot, flexShrink: 0,
              }} />
              <span style={{ fontSize: 11, fontWeight: 700, color: currentGroup.dot, textTransform: "uppercase", letterSpacing: 0.8 }}>
                {currentGroup.label}
              </span>
              <span style={{ fontSize: 11, color: D.txt3 }}>›</span>
              <span style={{ fontSize: 11, color: D.txt3, fontWeight: 500 }}>
                {linksData[pageSelected] || pageSelected}
              </span>
            </div>
          )}

          {/* Title row */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <h1 style={{ fontSize: 18, fontWeight: 700, color: D.txt1, margin: 0 }}>
              {linksData[pageSelected] || pageSelected}
            </h1>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <ErrorAlert error={error} setError={setError} duration={10000} />
              <span style={checKL_L1
                ? badge("#92400e", D.yellowLight)
                : badge("#065f46", D.greenLight)}>
                {checKL_L1 ? elakayAutoText("h_192e86c4711c01", "⚠ Not translated") : elakayAutoText("h_9e0b53f3207f33", "✓ Translated")}
              </span>
            </div>
          </div>
        </div>

        {/* Compare card */}
        <div style={card({ marginBottom: 16 })}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
            {currentGroup && (
              <span style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: 26, height: 26, borderRadius: 8, fontSize: 13,
                background: `${currentGroup.dot}18`, color: currentGroup.dot,
              }}>
                {currentGroup.icon}
              </span>
            )}
            <h3 style={{ fontSize: 13, fontWeight: 700, color: D.txt2, margin: 0 }}>{elakayAutoText("h_d31f1ef0a58d44", "⇄ Comparaison de langues")}</h3>
          </div>
          {compareLanguages()}
          {compare1Page()}
          {compare2Page()}
          {compare3Page()}
          {addByJson()}
        </div>

        {/* Editor card */}
        <div style={card()} ref={divLoadingPage}>
          <div style={{
            borderBottom: `1px solid ${D.cardBdr}`, paddingBottom: 12, marginBottom: 16,
            display: "flex", alignItems: "center", gap: 8,
          }}>
            {currentGroup && (
              <span style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: 26, height: 26, borderRadius: 8, fontSize: 13,
                background: `${currentGroup.dot}18`, color: currentGroup.dot,
              }}>
                {currentGroup.icon}
              </span>
            )}
            <h3 style={{ fontSize: 13, fontWeight: 700, color: D.txt2, margin: 0 }}>{elakayAutoText("h_dd49c292dfcbf9", "Éditeur de traduction")}</h3>
            {currentGroup && (
              <span style={{
                marginLeft: "auto", fontSize: 11, fontWeight: 600,
                color: currentGroup.dot, background: `${currentGroup.dot}18`,
                padding: "2px 8px", borderRadius: 10,
              }}>
                {currentGroup.label}
              </span>
            )}
          </div>
          {LoadingPage(pageSelected)}
        </div>
      </div>
    );
  };

  // ─── Render ───────────────────────────────────────────────────────────────────
  return (
    <Layout
      infoSource={infoSource}
      title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addLanguage.t008}
      loading={loading}
      SliderPunShow={false}
      {...infoSource?.allSettings?.layout}
    >
      <div style={infoSource.styleNav}>
        <div className="language-manager-shell" style={{ minHeight: "calc(100vh - 120px)", fontFamily: D.font, background: D.contentBg }}>
          {sideBarForm()}
          {contentForm()}
        </div>
        {loadingFormPage2()}
        <AlertPage showAlert={showAlert} setShowAlert={setShowAlert} />
      </div>
    </Layout>
  );
};

export default AddLanguage;
